import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { TableCell, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import formatCurrency from "../../unit/formatCurrency";
const TableCellRight = styled(TableCell)({
  textAlign: "right",
  fontFamily: "Roboto",
});

const CustomSummaryCashOutFlowTable = ({ ...props }) => {
  const value = props.value;
  const key = props.key;
  const dateList = props.dateList;
  const [showCashOutFlowChild, setShowCashOutFlowChild] = React.useState(false);
  return (
    <>
      <TableRow key={"cashflow_row_" + key}>
        <TableCell sx={{ paddingLeft: "50px" }}>
          {showCashOutFlowChild ? (
            <RemoveCircleIcon
              onClick={() => setShowCashOutFlowChild(!showCashOutFlowChild)}
              sx={{
                fontSize: "16px",
                color: "#506070",
                verticalAlign: "text-top",
                marginRight: "10px",
                cursor: "pointer",
              }}
            />
          ) : (
            <AddCircleIcon
              onClick={() => setShowCashOutFlowChild(!showCashOutFlowChild)}
              sx={{
                fontSize: "16px",
                color: "#506070",
                verticalAlign: "text-top",
                marginRight: "10px",
                cursor: "pointer",
              }}
            />
          )}

          {value.catName}
        </TableCell>
        {Object.keys(dateList).map((year: any) => {
          return dateList[year].map((week: any) => {
            return (
              <TableCellRight
                key={"cashflow_cell_" + key + "_" + year + "_" + week}
              >
                {value?.datalist[year + week]
                  ? formatCurrency(value?.datalist[year + week])
                  : ""}
              </TableCellRight>
            );
          });
        })}
        <TableCellRight>{formatCurrency(value.totalAmount)}</TableCellRight>
      </TableRow>
      {showCashOutFlowChild &&
        value?.childlist &&
        value?.childlist.map((child: any) => (
          <TableRow key={"cashflow_row_" + child.catName}>
            <TableCell sx={{ paddingLeft: "100px" }}>{child.catName}</TableCell>
            {Object.keys(dateList).map((year: any) => {
              return dateList[year].map((week: any) => {
                return (
                  <TableCellRight
                    key={
                      "cashflow_cell_" + child.catName + "_" + year + "_" + week
                    }
                  >
                    {child?.datalist[year + week]
                      ? formatCurrency(child?.datalist[year + week])
                      : ""}
                  </TableCellRight>
                );
              });
            })}
            <TableCellRight>{formatCurrency(child.totalAmount)}</TableCellRight>
          </TableRow>
        ))}
    </>
  );
};

export default CustomSummaryCashOutFlowTable;
